import { Colors, fontXSmall, type ColorName } from "~foundations";

export type BadgeStatus =
  | "secondary"
  | "tertiary"
  | "success"
  | "warning"
  | "danger"
  | "light"
  | "medium"
  | "dynamic-pricing";

type BadgeColors = {
  backgroundColor: string;
  textColor: ColorName;
};

export type BadgeProps = {
  status: BadgeStatus;
  text: string;
};

export const BadgeStatusColors: Record<BadgeStatus, BadgeColors> = {
  secondary: { backgroundColor: Colors.yellow200, textColor: "yellow600" },
  tertiary: { backgroundColor: Colors.purple200, textColor: "purple500" },
  success: { backgroundColor: Colors.green200, textColor: "green500" },
  warning: { backgroundColor: Colors.yellow500, textColor: "black" },
  danger: { backgroundColor: Colors.red200, textColor: "red500" },
  light: { backgroundColor: "transparent", textColor: "slate400" },
  medium: { backgroundColor: Colors.slate400, textColor: "white200" },
  "dynamic-pricing": { backgroundColor: Colors.green500, textColor: "white200" },
};

/**
 * Component | Badge
 *
 * @Figma https://www.figma.com/design/uJsnuoosxqn26Rot52zCXZ/%F0%9F%A7%B9-Swing-Design-System-v2?node-id=1178-31453&t=jMwCBMP3oKc4eYgi-4
 */
export function Badge(props: BadgeProps) {
  const { status, text } = props;
  const { backgroundColor, textColor } = BadgeStatusColors[status];
  return (
    <div
      css={{
        borderRadius: 4,
        padding: "0px 4px",
        height: 17, // This is based on the design system
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        width: "fit-content",
        ...fontXSmall({ color: textColor, fontWeight: 600 }),
      }}
    >
      {text}
    </div>
  );
}
